<template>
  <ion-page>
    <ion-header class="ion-no-border events-page-header">
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-button @click="openMenu">
            <ion-icon :icon="menuOutline"></ion-icon>
          </ion-button>
        </ion-buttons>
        <ion-title>Тренировки</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content class="main-background" :fullscreen="true" slot="fixed" :scroll-y="false">
      <ion-segment :value="selectedListSegment" @ionChange="listSegmentChange($event)" mode="md" class="custom-segment">
        <ion-segment-button value="all">
          <ion-label>Все</ion-label>
        </ion-segment-button>
        <ion-segment-button value="favourites">
          <ion-label>Избранное</ion-label>
        </ion-segment-button>
      </ion-segment>

      <ion-content class="bg-transparent programs-content" v-show="selectedListSegment == 'all'">
        <ion-accordion-group :value="selectedProgram">
          <div v-for="(program, programIdx) in programs" :key="programIdx">
            <ion-accordion class="bg-transparent" :value="program.programName">
              <ion-item slot="header" class="program-item" lines="none" color="violet">
                <div class="program-img-wrapper">
                  <img :src="programLogos[program.shortName] || getProgramImage(program.shortName)" alt="program logo" />
                </div>
              </ion-item>

              <ion-list slot="content" class="bg-transparent" lines="none">
                <ion-item color="violet" class="release-item release-add-item"
                  v-if="globalContext.isManager && !globalContext.offlineMode" @click="openNewReleaseForm(program)">
                  <ion-label class="ion-text-center">+</ion-label>
                </ion-item>

                <ion-item-sliding v-for="release in program.fullReleases" :key="release.id" name="itemSliding-all">
                  <ion-item color="violet" class="release-item" :detail="true" @click="openRelease(program, release)">
                    <ion-label class="ion-text-center">{{
                      program.programName + " " + release.releaseName
                    }}</ion-label>
                  </ion-item>
                  <ion-item-options side="end"
                    @ionSwipe="addToFavourites(program, release, isFavourite(program, release) ? false : true)">
                    <ion-item-option color="danger" @click="removeRelease(release, program)"
                      v-if="globalContext.isManager"><ion-icon :icon="trashOutline"></ion-icon></ion-item-option>
                    <ion-item-option @click="addToFavourites(program, release, true)" color="success"
                      v-show="!isFavourite(program, release)" expandable>
                      <ion-icon :icon="starOutline"></ion-icon>
                    </ion-item-option>
                    <ion-item-option @click="addToFavourites(program, release, false)" color="success"
                      v-show="isFavourite(program, release)" class="white-icon" expandable>
                      <ion-icon :icon="star"></ion-icon>
                    </ion-item-option>
                  </ion-item-options>
                </ion-item-sliding>
              </ion-list>
            </ion-accordion>
          </div>
        </ion-accordion-group>
        <ion-item class="bg-transparent fake-item" lines="none"></ion-item>
      </ion-content>

      <ion-content class="bg-transparent programs-content programs-content-favourites"
        v-show="selectedListSegment == 'favourites'">
        <div v-for="(program, programIdx) in programs" :key="programIdx">
          <ion-list slot="content" class="bg-transparent" lines="none">
            <div v-for="release in program.fullReleases" :key="release.id">
              <ion-item-sliding v-show="isFavourite(program, release)" name="itemSliding-favourites">
                <ion-item class="release-item release-favourite-item" color="violet" :detail="true"
                  @click="openRelease(program, release)">
                  <ion-label class="ion-text-center">{{
                    program.programName + " " + release.releaseName
                  }}</ion-label>
                </ion-item>
                <ion-item-options side="end"
                  @ionSwipe="addToFavourites(program, release, isFavourite(program, release) ? false : true)">
                  <ion-item-option @click="addToFavourites(program, release, true)" color="success"
                    v-show="!isFavourite(program, release)" expandable>
                    <ion-icon :icon="starOutline"></ion-icon>
                  </ion-item-option>
                  <ion-item-option @click="addToFavourites(program, release, false)" color="success"
                    v-show="isFavourite(program, release)" class="white-icon" expandable>
                    <ion-icon :icon="star"></ion-icon>
                  </ion-item-option>
                </ion-item-options>
              </ion-item-sliding>
            </div>
          </ion-list>
        </div>
        <ion-item class="bg-transparent fake-item" lines="none"></ion-item>
      </ion-content>

      <ion-modal :is-open="showNewReleaseForm" :breakpoints="[0, 0.5]" :initialBreakpoint="0.5"
        @didDismiss="closeNewReleaseForm()">
        <ion-header class="new-release-form">
          <ion-toolbar>
            <ion-title>Новый релиз</ion-title>
            <ion-buttons slot="end">
              <ion-button @click="closeNewReleaseForm()" slot="end" class="new-release-form-header-button">
                <ion-icon :icon="closeOutline" slot="icon-only"></ion-icon>
              </ion-button>
            </ion-buttons>
          </ion-toolbar>
        </ion-header>
        <ion-content class="new-release-form">
          <ion-item>
            <ion-label class="ion-text-center new-release-form-program">{{
              newReleaseProgram[0].programName
            }}</ion-label>
          </ion-item>
          <ion-item>
            <ion-input label="Номер релиза" label-placement="floating" fill="solid" type="text" placeholder="Номер релиза"
              v-model="newReleaseName" autocomplete="off" autocorrect="off"></ion-input>
          </ion-item>
          <div class="add-button-container">
            <ion-button @click="saveNewRelease(newReleaseProgram[0])">
              <ion-icon slot="icon-only" :icon="add" v-show="!newReleaseCreating"></ion-icon>
              <ion-spinner name="bubbles" v-show="newReleaseCreating"></ion-spinner>
            </ion-button>
          </div>
        </ion-content>
      </ion-modal>
    </ion-content>
  </ion-page>
</template>

<script lang="ts">
import { FavouriteRelease } from "@/model/favouriterelease.model";
import { GlobalContext } from "@/model/globalcontext.model";
import { Program } from "@/model/program.model";
import { ProgramRelease } from "@/model/programrelease.model";
import FilesystemCustomUtils from "@/services/filesystem.custom.utils";
import LogoService from "@/services/logo.service";
import UnicodeUtils from "@/services/unicode.utils";
import { CapacitorHttp } from "@capacitor/core";
import { Directory, Encoding, Filesystem } from "@capacitor/filesystem";
import { Preferences } from "@capacitor/preferences";
import {
    IonAccordion,
    IonAccordionGroup,
    IonButton,
    IonButtons,
    IonContent,
    IonHeader,
    IonIcon,
    IonInput,
    IonItem,
    IonItemOption,
    IonItemOptions,
    IonItemSliding,
    IonLabel,
    IonList,
    IonModal,
    IonPage,
    IonSegment,
    IonSegmentButton,
    IonSpinner,
    IonTitle,
    IonToolbar,
    alertController,
    isPlatform,
    menuController
} from "@ionic/vue";
import axios from "axios";
import { add, closeOutline, cloudDownloadOutline, homeOutline, menuOutline, star, starOutline, trashOutline } from "ionicons/icons";
import { defineComponent, inject } from "vue";
export default defineComponent({
  name: "Programs",
  components: {
    IonContent,
    IonPage,
    IonItem,
    IonAccordionGroup,
    IonAccordion,
    IonList,
    IonLabel,
    IonModal,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonButtons,
    IonButton,
    IonIcon,
    IonInput,
    IonSpinner,
    IonItemSliding,
    IonItemOptions,
    IonItemOption,
    IonSegment,
    IonSegmentButton,
  },
  setup() {
    const filesystemCustomUtils = new FilesystemCustomUtils();
    const globalContext = inject("globalContext") as GlobalContext;
    const isMobile = globalContext.isMobile;
    const FAVOURITES_DIRECTORY = "favourites";
    const unicodeUtils = new UnicodeUtils();
    const logoService = new LogoService();

    const getProgramImage = (shortName: string | undefined): string => {
      if (!shortName || shortName.trim() === '') {
        return require('@/theme/liga-logo-white.png');
      }
      
      try {
        return require(`@/theme/programs/${shortName}.png`);
      } catch (error) {
        console.warn(`Program image not found for ${shortName}, using Liga logo as fallback`);
        return require('@/theme/liga-logo-white.png');
      }
    };

    const openMenu = () => menuController.open("mainMenu");

    return {
      cloudDownloadOutline,
      closeOutline,
      add,
      menuOutline,
      openMenu,
      globalContext,
      filesystemCustomUtils,
      isMobile,
      starOutline,
      star,
      FAVOURITES_DIRECTORY,
      unicodeUtils,
      trashOutline,
      homeOutline,
      getProgramImage,
      logoService,
    };
  },
  data() {
    return {
      programs: Array<Program>(),
      favourites: Array<FavouriteRelease>(),
      showNewReleaseForm: false,
      newReleaseProgram: Array<Program>(),
      newReleaseName: "",
      newReleaseCreating: false,
      selectedProgram: "",
      selectedListSegment: "all",
      programLogos: {} as Record<string, string>,
    };
  },

  ionViewWillEnter() {
    Preferences.get({ key: "selectedProgram" }).then((result) => {
      if (result.value) {
        this.selectedProgram = result.value;
      }
    });
    this.getPrograms();
    this.getAllFavourites();
  },

  methods: {
    returnBack(componentName?: string) {
      this.$router.replace({
        name: componentName ? componentName : "Programs",
      });
    },
    closeSliding() {
      const itemSliding = document.getElementsByName(`itemSliding-${this.selectedListSegment}`);
      for (let i = 0; i < itemSliding.length; i++) {
        (itemSliding[i] as any).closeOpened();
      }
    },

    listSegmentChange(event: CustomEvent): void {
      this.selectedListSegment = event.detail.value;
      this.closeSliding();
    },

    async showAlert(alertTitle: string, alertMessage: string) {
      const alert = await alertController.create({
        header: alertTitle,
        message: alertMessage,
        buttons: ["OK"],
      });

      await alert.present();
    },

    async getPrograms() {
      if (this.globalContext.offlineMode) {
        //try to load local programs
        Filesystem.readFile({
          path: `${this.filesystemCustomUtils.PLAYLISTS_DIRECTORY}/${this.filesystemCustomUtils.PROGRAMS_PATH}`,
          directory: Directory.Data,
          encoding: Encoding.UTF8,
        })
          .then((programsFile) => {
            this.programs = [];
            let parsedData;
            try {
              parsedData = JSON.parse(typeof programsFile.data === "string" ? programsFile.data : "[]");
            } catch (e) {
              console.error("Local programs parse error", e);
              parsedData = [];
            }
            if (Array.isArray(parsedData)) {
              this.programs = parsedData;
            } else if (parsedData && typeof parsedData === "object") {
              this.programs = [parsedData];
            }
            this.programs.forEach((p) => {
              if (!p) return;
              p.fullReleases = Array.isArray(p.fullReleases) ? p.fullReleases : [];
              try {
                if (p.fullReleases.length) {
                  p.fullReleases.sort(function (a, b) {
                    const keyA =
                      ((a && a.releaseName && a.releaseName.length) || 0) > 1
                        ? (a.releaseName || "")
                        : a ? `0${a.releaseName}` : "0";
                    const keyB =
                      ((b && b.releaseName && b.releaseName.length) || 0) > 1
                        ? (b.releaseName || "")
                        : b ? `0${b.releaseName}` : "0";
                    if (keyA < keyB) return 1;
                    if (keyA > keyB) return -1;
                    return 0;
                  });
                }
              } catch (err) {
                console.warn("Sort releases skipped (offline)", err);
              }
            });
            this.loadProgramLogos();
            this.$nextTick(() => {
              Preferences.get({ key: "selectedProgram" }).then((result) => {
                if (result.value) {
                  this.selectedProgram = result.value;
                }
              });
            });
          })
          .catch((err) => {
            console.error("Failed to load local programs list", err);
          });
        return;
      }

      const tokenQuery = await Preferences.get({ key: "jwt" });
      const token = tokenQuery.value;

      const options = {
        url: `${process.env.VUE_APP_API_URL}api/programs-with-releases`,
        headers: { Authorization: `Bearer ${token}` },
        readTimeout: 60000,
      };

      await CapacitorHttp.get(options)
        .then((response) => {
          let data = response.data;
          if (typeof data === "string") {
            try {
              data = JSON.parse(data);
            } catch (e) {
              console.error("Programs response parse error", e);
              data = [];
            }
          }
          if (!Array.isArray(data)) {
            data = (data && (data.programs || data.data || data.list)) || [];
            if (!Array.isArray(data)) data = [];
          }
          this.programs = data;
          
          console.log('=== Programs loaded from API ===');
          console.log('Total programs:', this.programs.length);
          this.programs.forEach((p, idx) => {
            if (idx === 0 && p.fullReleases && p.fullReleases.length > 0) {
              console.log('First program releases (sample):');
              p.fullReleases.slice(0, 3).forEach(r => {
                console.log(`  - Release ${r.id}: ${r.releaseName}, contentSource:`, r.contentSource);
              });
            }
          });
          console.log('================================');
          
          this.programs.forEach((p) => {
            if (!p) return;
            p.fullReleases = Array.isArray(p.fullReleases) ? p.fullReleases : [];
            try {
              if (p.fullReleases.length) {
                p.fullReleases.sort(function (a, b) {
                  const keyA =
                    ((a && a.releaseName && a.releaseName.length) || 0) > 1
                      ? (a.releaseName || "")
                      : a ? `0${a.releaseName}` : "0";
                  const keyB =
                    ((b && b.releaseName && b.releaseName.length) || 0) > 1
                      ? (b.releaseName || "")
                      : b ? `0${b.releaseName}` : "0";
                  if (keyA < keyB) return 1;
                  if (keyA > keyB) return -1;
                  return 0;
                });
              }
            } catch (err) {
              console.warn("Sort releases skipped", err);
            }
          });
          if (this.isMobile) {
            try {
              this.filesystemCustomUtils.storeFile(
                btoa(JSON.stringify(this.programs)),
                this.filesystemCustomUtils.PROGRAMS_PATH,
                this.filesystemCustomUtils.PLAYLISTS_DIRECTORY
              );
            } catch (err) {
              console.warn("Store programs cache failed", err);
            }
          }
          this.loadProgramLogos();
          this.$nextTick(() => {
            Preferences.get({ key: "selectedProgram" }).then((result) => {
              if (result.value) {
                this.selectedProgram = result.value;
              }
            });
          });
        })
        .catch((ex) => {
          console.error(ex);
          this.$router.replace("/badconnection");
        });
    },

    async loadProgramLogos() {
      if (!Array.isArray(this.programs)) return;
      const loadPromises = this.programs.map((program: Program) => {
        if (program && program.shortName) {
          const shortName = program.shortName;
          return this.logoService
            .getProgramLogo(shortName)
            .then((logoUrl) => {
              if (shortName) this.programLogos[shortName] = logoUrl;
            })
            .catch((error) => {
              console.warn("Logo load failed for " + program.shortName, error);
            });
        }
        return Promise.resolve();
      });
      await Promise.all(loadPromises);
    },

    getAllFavourites() {
      if (isPlatform("ios") || isPlatform("android")) {
        this.favourites = new Array<FavouriteRelease>();
        Filesystem.mkdir({
          path: this.FAVOURITES_DIRECTORY,
          directory: Directory.Data,
          recursive: true,
        })
        .catch(() => {
          // directory exists
        })
        .finally(() => {
          Filesystem.readdir({
            path: this.FAVOURITES_DIRECTORY,
            directory: Directory.Data,
          })
            .then((favouritesDirs) => {
              for (let i = 0; i < favouritesDirs.files.length; i++) {
                Filesystem.readFile({
                  path: `${this.FAVOURITES_DIRECTORY}/${favouritesDirs.files[i].name}`,
                  directory: Directory.Data,
                  encoding: Encoding.UTF8,
                })
                  .then((res) => {
                    const favourite: FavouriteRelease = JSON.parse(
                      typeof res.data === 'string' ? res.data : ''
                    );
                    this.favourites.push(favourite);
                  })
                  .catch((err) => {
                    console.error("Failed to load favourite", err);
                  });
              }
            })
            .catch(() => {
              // not exists
            });
        })
      } else {
        this.favourites = new Array<FavouriteRelease>();
      }
    },

    isFavourite(program: Program, release: ProgramRelease) {
      const id = `${program.shortName}-${release.releaseName}`
      const favourite = this.favourites.find((f) => {
        return f.id === id;
      });

      if (undefined === favourite || null === favourite) return false;

      return favourite.favourite || false;
    },

    addToFavourites(program: Program, release: ProgramRelease, isFavourite: boolean) {
      const id = `${program.shortName}-${release.releaseName}`;
      let isNew = false;
      let favourite = this.favourites.find((f) => {
        return f.id === id;
      });

      if (undefined === favourite || null === favourite) {
        favourite = new FavouriteRelease(id);
        isNew = true;
      }

      favourite.favourite = isFavourite;

      this.filesystemCustomUtils.storeFile(
        this.unicodeUtils.toBase64(JSON.stringify(favourite)),
        `${id}-favourite.json`,
        `${this.FAVOURITES_DIRECTORY}`
      );

      if (isNew) {
        this.favourites.push(favourite);
      }
      this.closeSliding();
    },

    async openRelease(program: Program, release: ProgramRelease) {
      await Preferences.set({
        key: "selectedProgram",
        value: program.programName || "",
      });

      Preferences.set({
        key: "releaseMeta",
        value: JSON.stringify({
          programName: program.programName,
          programShortName: program.shortName,
          release: release.releaseName,
          releaseVisible: String(release.visible),
          releaseId: String(release.id),
          contentSource: release.contentSource || 'GOOGLE',
        }),
      }).then(() => {
        this.$router.push({
          name: "ReleasePage",
        });
      });
    },

    openNewReleaseForm(program: Program) {
      this.showNewReleaseForm = true;
      this.newReleaseName = "";
      this.newReleaseProgram = new Array<Program>();
      this.newReleaseProgram.push(program);
    },

    closeNewReleaseForm() {
      this.showNewReleaseForm = false;
    },

    saveNewRelease(program: Program) {
      if (this.newReleaseName.trim().length < 1) {
        this.showAlert("Ошибка", "Укажите номер или название релиза.");
      } else {
        this.newReleaseCreating = true;
        this.createRelease(program)
          .then((newRelease) => {
            this.showNewReleaseForm = false;
            this.programs.map((p) => {
              if (p.id === program.id && p.fullReleases) {
                p.fullReleases.push(newRelease);
              }
            });
          })
          .finally(() => {
            this.newReleaseCreating = false;
          });
      }
    },

    async createRelease(program: Program): Promise<ProgramRelease> {
      const tokenQuery = await Preferences.get({ key: "jwt" });
      const token = tokenQuery.value;

      return new Promise<ProgramRelease>((resolve) => {
        if (this.isMobile) {
          const options = {
            url: `${process.env.VUE_APP_API_URL}api/releases`,
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            readTimeout: 60000,
            data: {
              releaseName: this.newReleaseName,
              visible: false,
              programId: program.id,
            },
          };

          CapacitorHttp.post(options)
            .then((result) => {
              resolve(result.data);
            })
            .catch(() => {
              this.$router.replace("/badconnection");
            });
        } else {
          axios
            .post("api/releases", {
              releaseName: this.newReleaseName,
              visible: false,
              programId: program.id,
            })
            .then((result) => {
              resolve(result.data);
            })
            .catch((err) => {
              console.log(err);
              // this.$router.replace('/badconnection');
            });
        }
      });
    },

    async removeRelease(release: ProgramRelease, program: Program) {
      const tokenQuery = await Preferences.get({ key: "jwt" });
      const token = tokenQuery.value;

      if (this.isMobile) {
        const options = {
          url: `${process.env.VUE_APP_API_URL}api/releases/${release.id}`,
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          readTimeout: 60000,
        };

        CapacitorHttp.delete(options)
          .then(() => {
            this.programs.map((p) => {
              if (p.id === program.id && p.fullReleases) {
                p.fullReleases = p.fullReleases.filter((r) => {
                  return r.id !== release.id;
                });
              }
            });
          })
          .catch(() => {
            this.$router.replace("/badconnection");
          })
          .finally(() => {
            this.closeSliding();
          });
      } else {
        axios
          .delete(`api/releases/${release.id}`)
          .then(() => {
            this.programs.map((p) => {
              if (p.id === program.id && p.fullReleases) {
                p.fullReleases = p.fullReleases.filter((r) => {
                  return r.id !== release.id;
                });
              }
            });
          })
          .catch((err) => {
            console.log(err);
            // this.$router.replace('/badconnection');
          });
      }
    },
  },
});
</script>

<style scoped>
h1 {
  letter-spacing: 0.08em;
}

.program-main {
  background-color: black;
  opacity: 0.9;
}

.program-item {
  --background: rgba(67, 67, 67, 0.7);
  color: white;
  --color-hover: white;
  font-weight: bold;
  --min-height: 100px;
  margin-bottom: 5px;
  border-bottom: 1px solid rgba(67, 67, 67, .5);
}

.program-img-wrapper {
  width: 100%;
  max-height: 100%;
  display: flex;
  justify-content: center;
}

.program-img-wrapper img {
  scale: 0.7;
  object-fit: scale-down;
}

.release-item {
  --background: rgba(134, 134, 134, 0.5);
  color: white !important;
  --min-height: 5em;
  font-weight: bold;
  border-bottom: 1px solid rgba(67, 67, 67, .5);
}

.release-favourite-item {
  border: unset !important;
  margin-bottom: 5px !important;
}

.release-item ion-label {
  font-family: 'Montserrat';
  color: white;
}

.programs-content-favourites ion-item-option {
  margin-bottom: 5px !important;
}

.release-add-item {
  --min-height: 60px;
  border-bottom: 1px solid rgba(67, 67, 67, .5);
}

.release-option {
  --background: var(--ion-color-orange);
}

.release-option ion-icon {
  color: white;
  scale: 1.5;
}

.release-container {
  position: relative;
}

.download-progress {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  z-index: 100;
  background: var(--ion-color-orange);
  opacity: 0.6;
}

.new-release-form {
  --background: #1f1f1f;
}

.new-release-form ion-toolbar {
  --background: #1f1f1f;
  color: white;
}

.new-release-form ion-item {
  --background: #272727;
  color: white;
}

.new-release-form-program {
  color: white;
  font-size: 1.2em;
  font-weight: bold;
}

.add-button-container {
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  margin-top: 20px;
}

.add-button-container ion-button {
  --background: var(--ion-color-orange);
  --background-activated: var(--ion-color-orange-tint);
  width: 50px;
  height: 50px;
  --border-radius: 25px;
}

.new-release-form-header-button {
  color: white !important;
  --background-activated: transparent !important;
}

ion-item::part(detail-icon) {
  color: white;
}

ion-input {
  --padding-start: 1em;
  --color: white;
  text-align: center;
}

/* 
  ##Device = Desktops
  ##Screen = 1281px to higher resolution desktops
*/

@media (min-width: 1281px) {
  .program-img-wrapper img {
    width: 30%;
  }
}

/* 
  ##Device = Laptops, Desktops
  ##Screen = B/w 1025px to 1280px
*/

@media (min-width: 1025px) and (max-width: 1280px) {
  .program-img-wrapper img {
    width: 30%;
  }
}

/* 
  ##Device = Tablets, Ipads (portrait)
  ##Screen = B/w 768px to 1024px
*/

@media (min-width: 768px) and (max-width: 1024px) {
  .program-img-wrapper img {
    width: 30%;
  }
}

/* 
  ##Device = Tablets, Ipads (landscape)
  ##Screen = B/w 768px to 1024px
*/
@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  .program-img-wrapper img {
    width: 30%;
  }
}
</style>